import { useCallback, useEffect, useRef, useState } from "react";
import { ALERT_CONFIG } from "../../../helpers/config";
import { cleanupModalArtifacts, scheduleModalCleanup } from "../../../utils/helpers/modalLifecycle";

export const AlertModal = ({ message, type = "success", onClose, isPrint = false, handlePrint }) => {
  const [show, setShow] = useState(false);
  const closeTimerRef = useRef(null);
  const showTimerRef = useRef(null);
  const isClosingRef = useRef(false);
  const config = ALERT_CONFIG[type];

  useEffect(() => {
    cleanupModalArtifacts();
    showTimerRef.current = window.setTimeout(() => {
      setShow(true);
    }, 100);

    return () => {
      window.clearTimeout(showTimerRef.current);
      window.clearTimeout(closeTimerRef.current);
      scheduleModalCleanup();
    };
  }, []);

  const closeWith = useCallback((callback) => {
    if (isClosingRef.current) return;

    isClosingRef.current = true;
    setShow(false);
    closeTimerRef.current = window.setTimeout(() => {
      callback?.();
      scheduleModalCleanup({ delay: 0 });
    }, 300);
  }, []);

  const handleClose = useCallback(() => closeWith(onClose), [closeWith, onClose]);
  const handlePrintAndClose = useCallback(() => closeWith(handlePrint), [closeWith, handlePrint]);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") handleClose();
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [handleClose]);

  return (
    <div
      className={`modal modal-blur fade ${show ? "show" : ""}`}
      style={{ display: "block", backgroundColor: "rgba(0,0,0,0.3)" }}
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
      aria-hidden={!show}>
      <div className="modal-dialog modal-sm modal-dialog-centered">
        <div
          className="modal-content position-relative"
          style={
            {
              // borderTop: `3px solid ${config.color}`,
            }
          }>
          <button type="button" className="btn-close ms-auto me-2 mt-2" onClick={handleClose} aria-label="Close" />

          <div className="modal-body text-center py-4">
            <div
              className="avatar avatar-xl rounded-circle my-3 mx-auto d-flex align-items-center justify-content-center"
              style={{ backgroundColor: config.bgIcon }}>
              {config.icon}
            </div>

            <h3 className="mb-1 text-capitalize fw-bolder">{type}</h3>
            <div className="text-secondary">{message}</div>
          </div>

          <div className="modal-footer border-0 pt-0">
            {isPrint && (
              <button
                type="button"
                className="btn btn-outline-primary w-100 d-flex align-items-center justify-content-center gap-2 "
                style={{ cursor: "pointer" }}
                onClick={handlePrintAndClose}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-printer">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2" />
                  <path d="M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4" />
                  <path d="M7 15a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2l0 -4" />
                </svg>
                Print
              </button>
            )}

            <button
              type="button"
              className={`btn btn-primary w-100 ${isPrint ? "bg-info" : ""} cursor-pointer`}
              // style={{ color: "#fff", backgroundColor: config.color, cursor: "pointer" }}
              onClick={handleClose}
              autoFocus>
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
